import React, { Fragment } from "react";

const ApprovalItem = ({ employerapproval }) => {
  return (
    <Fragment>
      <div className="user-section-alt">
        <div className="friends-user-container">
          <div className="friend-user-avi-container">
            <div className="avi-color-border blue">
              <div className="friend-user-avi"></div>
            </div>
          </div>
          <div className="friend-user-info">
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">
                    {employerapproval.companyname}
                  </span>
                </li>
                <li className="user-online-item">
                  {employerapproval.firstname} {employerapproval.lastname}
                </li>
                <li className="user-online-item">
                  {employerapproval.location.city},{" "}
                  {employerapproval.location.state}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="friends-buttons-container">
          <div className="friend-button-container">
            <button className="friend-button background-blue">
              <i className="fas fa-user-minus mx-5"></i>
              Remove
            </button>
          </div>
          <i className="fas fa-ellipsis-v fa-lg ellipsis-pos blue"></i>
          <div className="modal">
            <ul className="modal-items">
              <li className="modal-item">
                <i className="fas fa-flag mx-5 white"></i>
                Report
              </li>
              <li className="modal-item">
                <i className="fas fa-ban mx-5 white"></i>
                Block
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ApprovalItem;
